import { emptyGuid, isEmptyGuid } from '../utils/emptyGuid'
import { observable, makeObservable, action } from 'mobx'
import apiClient from '../utils/api/apiClient'
import { APIEndpoints } from '../utils/api/apiConfig'
import axios from 'axios'
const CancelToken = axios.CancelToken
let cancel

class StorehouseTreeStore {
  constructor(appStore) {
    makeObservable(this, {
      maxUnitType: observable,
      loadedStorehouseIds: observable,
      loadedStorehouses: observable,
      storehousesLoading: observable,
      allLoaded: observable,
      allStorehousesLoading: observable,
      error: observable,
      setError: action,
      clearError: action,
      setMaxUnitType: action,
      resetStorehouses: action,
      setStorehousesLoading: action,
      setAllStorehousesLoading: action,
      setLoadedStorehouses: action,
      setAllLoaded: action,
    })

    this.app = appStore
  }
  maxUnitType = null
  loadedStorehouseIds = []
  loadedStorehouses = []
  storehousesLoading = false
  allLoaded = false
  allStorehousesLoading = false
  error = ''
  setAllLoaded(bool) {
    this.allLoaded = bool
  }
  setStorehousesLoading(bool) {
    this.storehousesLoading = bool
  }
  setAllStorehousesLoading(bool) {
    this.allStorehousesLoading = bool
  }
  setLoadedStorehouses(storehouses) {
    this.loadedStorehouses = storehouses
  }
  setError(message) {
    this.error = message
  }

  clearError() {
    this.error = ''
  }

  resetStorehouses() {
    this.loadedStorehouseIds = []
    this.loadedStorehouses = []
    this.allLoaded = false
  }
  setMaxUnitType(type) {
    this.maxUnitType = type
  }
  async getStorehouses(storehouseParentId = emptyGuid) {
    this.loadAllStorehouses() //loadAll in background
    if (this.loadedStorehouseIds.includes(storehouseParentId)) {
      return this.loadedStorehouses
    } else if (this.storehousesLoading) {
      await this.app.uiStore.waitUntilLoaded(
        100,
        'app.storehouseTreeStore.storehousesLoading'
      )
      return this.getStorehouses(storehouseParentId)
    } else {
      this.setStorehousesLoading(true)
      let _newLoadedStorehouses = await this.loadTree(storehouseParentId)
      if (!this.allLoaded) {
        this.setLoadedStorehouses([
          ...this.loadedStorehouses,
          ..._newLoadedStorehouses,
        ])
      }
      this.setStorehousesLoading(false)
      return this.loadedStorehouses
    }
  }

  async loadTree(storehouseParentId = emptyGuid) {
    this.loadedStorehouseIds.push(storehouseParentId)
    const params = {
      parentUnitId: storehouseParentId,
      parentUnitType: 'location',
    }
    if (!isEmptyGuid(storehouseParentId)) {
      let foundItem = this.loadedStorehouses.find(
        (obj) => obj.id === storehouseParentId
      )
      if (foundItem) {
        params['parentUnitType'] = foundItem.stockUnitType
      }
    }
    if (this.maxUnitType) {
      params['maxUnitType'] = this.maxUnitType
    }
    return await apiClient.postJson(APIEndpoints.storehouseTree, params)
  }

  async loadAllStorehouses() {
    if (this.allLoaded) {
      return this.loadedStorehouses
    } else if (this.allStorehousesLoading) {
      await this.app.uiStore.waitUntilLoaded(
        100,
        'app.storehouseTreeStore.allStorehousesLoading'
      )
      return this.loadAllStorehouses()
    } else {
      this.setAllStorehousesLoading(true)
      const params = {}
      if (this.maxUnitType) {
        params['maxUnitType'] = this.maxUnitType
      }
      let allStorehouses = await apiClient.postJson(
        APIEndpoints.storehouseTree,
        params
      )
      this.resetStorehouses()
      this.loadedStorehouseIds.push(emptyGuid)
      allStorehouses.forEach((storehouse) => {
        this.loadedStorehouseIds.push(storehouse.id)
      })
      this.setLoadedStorehouses(allStorehouses)
      this.setAllLoaded(true)
      this.setAllStorehousesLoading(false)
    }
  }

  async getStorehouse(storehouseId) {
    let foundItem = this.loadedStorehouses.find(
      (obj) => obj.id === storehouseId
    )
    return await apiClient.getJson(
      APIEndpoints.storehouseTreeNode(
        storehouseId,
        foundItem?.stockUnitType ?? null
      )
    )
  }

  cancelGetFilteredStorehouseTrees() {
    //cancel previous calls that are still pending
    cancel && cancel()
  }

  async getFilteredStorehouses(searchValue) {
    this.cancelGetFilteredStorehouseTrees()
    const cancelToken = new CancelToken((c) => {
      cancel = c
    })

    const params = {
      parentUnitId: emptyGuid,
      parentUnitType: 'location',
      coordinates: searchValue,
    }

    if (this.maxUnitType) {
      params.maxUnitType = this.maxUnitType
    }

    try {
      const response = await apiClient.postJson(
        APIEndpoints.storehouseTree,
        params,
        true,
        false,
        true,
        { cancelToken }
      )
      return response
    } catch (e) {
      return []
    }
  }
}
export default StorehouseTreeStore
